import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useHasDeepPaymentProviderIntegrationAccess = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const canViewDeepPaymentProviderIntegration: boolean = useMemo(() => {
    return (
      metaData.featureFlags &&
      metaData.featureFlags.DeepPaymentProviderIntegration
    );
  }, [metaData]);

  return { canViewDeepPaymentProviderIntegration };
};
